module.exports = __webpack_public_path__ + "static/media/IT220.e533ac48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plasticProducts/IT220.jpg
// module id = 244
// module chunks = 0